import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SecureLocalService} from '../../../core/secure-local.service';
import {VibaEventsService} from './viba-events.service';

@Injectable({
  providedIn: 'root',
})
export class VibaQueueService {
  constructor(private http: HttpClient,
              private eventService: VibaEventsService,
              private secureService: SecureLocalService) {
  }

  public getQueueData(): Observable<Object> {
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken),
    };

    return this.http.get(webRTCAgentData.queueServerUrl +'/agent/queues', options);
  }

  public agentLogin(agentData){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    let orgId = localStorage.getItem('selectedOrganization');
    const options = {
      headers: new HttpHeaders().
      set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
      set('Content-Type', 'application/json').
      set('accept', '*/*')
    };
    let body = {
      userId: agentData.userId,
      fullName: agentData.userName,
      sessionId: agentData.sessionId,
      queues: agentData.queues.join(','),
      token: agentData.token,
      device: 'WEB',
      orgId: orgId
    };

    this.http.post(webRTCAgentData.queueServerUrl +'/agent/login',JSON.stringify(body),options).subscribe(
      // Don't log full object - fix veracode security flow
      //  (status)=> console.log(status)
    );
  }

  public agentLogout(userId){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    if (webRTCAgentData) {
      const options = {headers: new HttpHeaders().
        set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
        set('Content-Type', 'application/json').
        set('accept', '*/*')
      };
      this.http.post(webRTCAgentData.queueServerUrl + '/agent/logout',{},options).subscribe(() => console.log("Agent logout from queue " + userId));
    }
  }

  public agentPause(userId){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    const options = {headers: new HttpHeaders().
      set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
      set('Content-Type', 'application/json').
      set('accept', '*/*')
    };
    this.http.post(webRTCAgentData.queueServerUrl + '/agent/pause',{},options).subscribe(() => console.log("Agent paused on refresh" + userId));
  }

  public agentLogoutClosed(userId){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    const options = {headers: new HttpHeaders().
      set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
      set('Content-Type', 'application/json').
      set('accept', '*/*')
    };
    this.http.post(webRTCAgentData.queueServerUrl + '/agent/logoutClosed',{},options).subscribe(() => console.log("Agent logout closed from queue " + userId));
  }

  public holdCall(agentData){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    let orgId = localStorage.getItem('selectedOrganization');
    const options = {
      headers: new HttpHeaders().
      set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
      set('Content-Type', 'application/json').
      set('accept', '*/*')
    };

    this.http.post(webRTCAgentData.queueServerUrl +'/agent/holdCall',JSON.stringify(agentData),options).subscribe(
      // Don't log full object - fix veracode security flow
      //  (status)=> console.log(status)
    );
  }

  public endHoldCall(agentData){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    let orgId = localStorage.getItem('selectedOrganization');
    const options = {
      headers: new HttpHeaders().
      set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
      set('Content-Type', 'application/json').
      set('accept', '*/*')
    };

    this.http.post(webRTCAgentData.queueServerUrl +'/agent/endHoldCall',JSON.stringify(agentData),options).subscribe(
      // Don't log full object - fix veracode security flow
      //  (status)=> console.log(status)
    );
  }

  public submitReport(agentData){
    const webRTCAgentData = this.secureService.geItem('web-rtc-agent-data');
    let orgId = localStorage.getItem('selectedOrganization');
    const options = {
      headers: new HttpHeaders().
      set('Authorization', 'Bearer ' + webRTCAgentData.qsAccessToken).
      set('Content-Type', 'application/json').
      set('accept', '*/*')
    };

    this.http.post(webRTCAgentData.queueServerUrl +'/agent/submitReport',JSON.stringify(agentData),options).subscribe(
      // Don't log full object - fix veracode security flow
      //  (status)=> console.log(status)
    );
  }
}
